var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-new"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "ca-info"
  }, [_c('li', [_vm._v("\n      姓名"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "inter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.name),
      expression: "name",
      modifiers: {
        "trim": true
      }
    }],
    ref: "customerName",
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": "请填写"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('li', [_vm._v("\n      手机号码"), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")]), _vm._v(" "), _c('span', {
    staticClass: "inter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.mobile),
      expression: "mobile",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "ime-mode": "disabled"
    },
    attrs: {
      "type": "tel",
      "placeholder": "请填写",
      "maxlength": "11",
      "value": ""
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('li', [_vm._v("\n      回执编号"), _c('span', {
    staticClass: "red"
  }), _vm._v(" "), _c('span', {
    staticClass: "inter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.survey_code),
      expression: "survey_code",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请填写风险评估问卷的回执编号",
      "maxlength": "15",
      "value": ""
    },
    domProps: {
      "value": (_vm.survey_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.survey_code = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "actions mt-50"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStage
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('p', {
    staticClass: "mt-50",
    staticStyle: {
      "font-size": "13px",
      "padding": "5px 20px"
    }
  }, [_vm._v("\n      温馨提示：订单创建过程中遇到问题，可在企业号【我的客户】栏目中直接发送问题消息到后台，值班技术支持会尽快给您回复。\n    ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "100px",
      "font-size": "13px",
      "padding": "5px 20px"
    }
  }, [_vm._v("\n      有疑问？"), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.toFaq
    }
  }, [_vm._v("点这里")])])], 1), _vm._v(" "), _c('mt-popup', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.selectPhoneVisible),
      callback: function($$v) {
        _vm.selectPhoneVisible = $$v
      },
      expression: "selectPhoneVisible"
    }
  }, [_c('mt-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "showToolbar": true,
      "slots": _vm.selectCustomerList
    },
    on: {
      "change": _vm.onSelectCustomerChange
    }
  }, [_c('mt-button', {
    staticStyle: {
      "width": "100%",
      "height": "41px",
      "letter-spacing": "2px"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.onSubmitClick
    }
  }, [_vm._v("点击选择套餐")])], 1)], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("购买人信息"), _c('span', [_vm._v("（*项为必填项）")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-0bb43d16","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/order/OrderNew.vue
// module id = 222
// module chunks = 0